import { Theme } from '@desygner/ui-common-components';

const {
  Border,
  Button,
  Card,
  Color,
  Components,
  Form,
  Grid,
  Icon,
  Modal,
  Placeholder,
  Screen,
  Scrollbar,
  Sizes,
  Spacing,
  Transition,
  Typography,
  ZIndex,
} = Theme;

const Version = 'light';

export {
  Border,
  Button,
  Card,
  Color,
  Components,
  Form,
  Grid,
  Icon,
  Modal,
  Placeholder,
  Screen,
  Scrollbar,
  Sizes,
  Spacing,
  Transition,
  Typography,
  Version,
  ZIndex,
};
